import { CustomTooltipComponentPosition } from './../../model/enum/custom-tooltip.enum';
import { Component, OnInit, ViewChild, ElementRef, Input, OnChanges, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-custom-tooltip',
  templateUrl: './custom-tooltip.component.html'
})
export class CustomTooltipComponent implements OnInit, OnChanges {

  _position = 'RIGHT';
  get position(): string {
    return this._position;
  }
  @Input() set position(value: string) {
    this._position = value;
  }
  @Input() eventTrigger = 'MOUSE_HOVER';

  CustomTooltipComponentPosition = CustomTooltipComponentPosition;
  viewMore: boolean;
  btnWidth = 0;
  btnHeight = 0;
  @ViewChild('btnWrapper') btnWrapper: ElementRef<HTMLElement>;
  constructor(
    public changeDetector: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.setBtnDimensions();
  }

  ngOnChanges() {
    this.setBtnDimensions();
  }

  triggerShow(event) {
    if (this.eventTrigger == 'MOUSE_HOVER' && event == 'mouseenter') {
      this.viewMore = true;
    }
    if (this.eventTrigger == 'CLICK' && event == 'click') {
      this.viewMore = true;
    }
    if (event == 'mouseleave') {
      this.viewMore = false;
    }
  }

  setBtnDimensions() {
    this.btnWidth = this.btnWrapper?.nativeElement?.offsetWidth - 5;
    this.btnHeight = this.btnWrapper?.nativeElement?.offsetHeight - 5;
    this.changeDetector.detectChanges()
  }

  getClassPosition() {
    switch (CustomTooltipComponentPosition[this.position]) {
      case CustomTooltipComponentPosition.TOP:
        return 'tooltip-top';
      case CustomTooltipComponentPosition.TOP_RIGHT:
        return 'tooltip-top-right';
      case CustomTooltipComponentPosition.TOP_LEFT:
        return 'tooltip-top-left';
      case CustomTooltipComponentPosition.RIGHT:
        return 'tooltip-right';
      case CustomTooltipComponentPosition.BOTTOM:
        return 'tooltip-bottom';
      case CustomTooltipComponentPosition.BOTTOM_RIGHT:
        return 'tooltip-bottom-right';
      case CustomTooltipComponentPosition.BOTTOM_LEFT:
        return 'tooltip-bottom-left';
      case CustomTooltipComponentPosition.LEFT:
        return 'tooltip-left';
    }

  }

  getOffsetStyle() {
    switch (CustomTooltipComponentPosition[this.position]) {
      case CustomTooltipComponentPosition.TOP:
      case CustomTooltipComponentPosition.TOP_RIGHT:
      case CustomTooltipComponentPosition.TOP_LEFT:
        return { bottom: this.btnHeight + 'px' };
      case CustomTooltipComponentPosition.BOTTOM:
      case CustomTooltipComponentPosition.BOTTOM_RIGHT:
      case CustomTooltipComponentPosition.BOTTOM_LEFT:
        return { top: this.btnHeight + 'px' };
      case CustomTooltipComponentPosition.RIGHT:
        return { left: this.btnWidth + 'px' };
      case CustomTooltipComponentPosition.LEFT:
        return { right: this.btnWidth + 'px' };
    }
  }
}
